module.exports = __webpack_public_path__ + "img/44.475fb6ee.png";